import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { AIAgentAnimatedLoader } from '../../../../components/AIAgentAnimatedLoader';
import { AnimatedText } from '../../../../components/AnimatedText';

import { StyledLoaderWrapper } from './styles';

export const AIOutreachInitialLoader = () => {
  const { t } = useTranslation();

  const loadingTexts = useMemo(
    () => Array.from({ length: 28 }, (_, i) => t(`email_agent.loader.message_${i + 1}`) + '...'),
    [t]
  );

  return (
    <StyledLoaderWrapper data-automation="AIOutreachLoading">
      <AIAgentAnimatedLoader width={160} height={160} />
      <AnimatedText texts={loadingTexts} variant="emailAgent" />
    </StyledLoaderWrapper>
  );
};
